import { render, staticRenderFns } from "./ChangePasswordFromEmail.vue?vue&type=template&id=5f8906fe&scoped=true&"
import script from "./ChangePasswordFromEmail.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordFromEmail.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordFromEmail.vue?vue&type=style&index=0&id=5f8906fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8906fe",
  null
  
)

export default component.exports